import { useState } from 'react';
import styled, { css } from 'styled-components';
import { MenuItemElementViewModelDiscriminator, type ProductListMenuItemViewModel } from 'autogen/swagger/all';
import { ButtonWithIcon } from 'components/Button';
import Menu from 'components/generic/menu';
import Icon from 'components/Icon';
import { BrandSpecificMenuItemStyling } from '../shared/styles';
import ItemsRenderer from './ItemsRenderer';

/* #region styles */
const ArrowDown = styled(Icon)<{ $isExpanded: boolean }>`
    ${({ $isExpanded }) =>
        $isExpanded &&
        css`
            transform: rotate(180deg);
        `};
`;

const StyledButtonWithIcon = styled(ButtonWithIcon)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 4px;
`;

const StyledMenuItemAnchor = styled(Menu.Item.Action)<{ selected: boolean }>`
    position: relative;
    ${BrandSpecificMenuItemStyling}
`;
/* #endregion */

export default function AccordionMenuItem({ item }: { item: ProductListMenuItemViewModel }) {
    const [isExpanded, setIsExpanded] = useState(item.isSelected);

    return (
        <>
            {MenuItemElementViewModelDiscriminator(
                item.itemElement,
                ({ text, cssClass }) => (
                    <Menu.Item
                        selected={item.isSelected}
                        className={cssClass}
                        afterSlot={
                            <StyledButtonWithIcon
                                size="sm"
                                forwardedAs="div"
                                variant="ghostOnLight"
                                onClick={(e) => {
                                    setIsExpanded((x) => !x);
                                    e.preventDefault();
                                }}
                                icon={<ArrowDown type="ChevronDown" size={16} $isExpanded={isExpanded} />}
                            />
                        }
                    >
                        {text}
                    </Menu.Item>
                ),
                ({ text, link: action }) => (
                    <StyledMenuItemAnchor
                        selected={item.isSelected}
                        action={action}
                        afterSlot={
                            <StyledButtonWithIcon
                                size="sm"
                                forwardedAs="div"
                                variant="ghostOnLight"
                                onClick={(e) => {
                                    setIsExpanded((x) => !x);
                                    e.preventDefault();
                                }}
                                icon={<ArrowDown type="ChevronDown" size={16} $isExpanded={isExpanded} />}
                            />
                        }
                    >
                        {text}
                    </StyledMenuItemAnchor>
                ),
                () => null
            )}

            {/* Recursion */}
            {isExpanded && <ItemsRenderer menuItems={item.children} level={item.level} />}
        </>
    );
}
